import { DateTime } from 'luxon';
import axios from 'axios';

// EST timezone
const TIMEZONE = 'America/New_York';
const DATE_FORMAT = 'LLLL dd, yyyy hh:mma';

export const secondsToDateTime = (seconds: number): DateTime =>
  DateTime.fromSeconds(seconds).setZone(TIMEZONE);

export const getCurrentDateTime = (): DateTime =>
  DateTime.now().setZone(TIMEZONE);

export const parseISODate = (isoTimestamp: string): DateTime =>
  DateTime.fromISO(isoTimestamp).setZone(TIMEZONE);

export const humanizeISODate = (isoTimestamp: string): string =>
  parseISODate(isoTimestamp).toFormat(DATE_FORMAT);

export const parseAxiosError = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    return error.response?.data?.message || error.message;
  }
  return '';
};

export const getRandomFromArray = <T>(array: T[]): T => {
  const index = Math.floor(Math.random() * array.length);
  return array[index];
};

export const truncateString = (text: string, maxCharacters: number) => {
  if (text.length === 0) {
    return text;
  }
  return `${text.slice(0, maxCharacters)}...`;
};

const prettify = (val: String) => {
  if (!val) {
    return '';
  }
  const result = val.replace(/([A-Z])/g, ' $1');
  const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  return finalResult.trim();
};

const generateKey = () => (Math.random() + 1).toString(36).substring(7);

const capitalize = (word: String) => {
  const result = word.replace(/([A-Z])/g, ' $1');
  const capitalizedWord = result.replace(/(^|\s)\S/g, firstLetter =>
    firstLetter.toUpperCase(),
  );
  return capitalizedWord.trim();
};

const StringUtils = {
  prettify,
  generateKey,
  capitalize,
};

export default StringUtils;

export const ObjectUtils = {
  filterEmpty(cObj: Record<string, any>) {
    const cleanData = Object.entries(cObj)
      .filter(([, value]) => value !== undefined)
      .reduce((obj: any, [key, value]) => {
        // eslint-disable-next-line no-param-reassign
        obj[key] = value;
        return obj;
      }, {});
    return cleanData;
  },
};

export const errorMessage = (err: any) =>
  err.response?.data?.message ||
  err.response?.data?.msg ||
  (err as Error).message;

export const csvToJSON = (csv: string): any => {
  const lines = csv.split('\n');

  const result = [];
  const headers = lines[0].split(',');

  for (let i = 1; i < lines.length; i++) {
    const obj: any = {};
    const currentline = lines[i].split(',');

    for (let j = 0; j < headers.length; j++) {
      obj[headers[j]] = currentline[j];
    }
    // @ts-ignore
    result.push(obj);
  }

  return JSON.stringify(result);
};

export const jsonToCSV = (json: any): string => {
  const fields = Object.keys(json[0]);
  function replacer(_key: any, value: null) {
    return value === null ? '' : value;
  }
  let csv = json.map((row: { [x: string]: any }) =>
    fields.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','),
  );
  csv.unshift(fields.join(','));
  csv = csv.join('\r\n');
  return csv;
};
